import { TLocoType } from 'shared/hooks/use-loco-translation'
import { ConditionEnum, SendingFrequencyEnum } from '../types/reminder-interface'

export const getConditionsData = (t: TLocoType) => [
  {
    id: ConditionEnum.Enrollment,
    caption: t('dashboard.course.reminder.settings.condition_enrollment'),
  },
  {
    id: ConditionEnum.LastLogin,
    caption: t('dashboard.course.reminder.settings.condition_last_login'),
  },
]

export const getSendingFrequencyOptions = (t: TLocoType) => [
  {
    id: SendingFrequencyEnum.Once,
    caption: t('dashboard.course.reminder.settings.sending_frequency_once'),
  },
  {
    id: SendingFrequencyEnum.Repeat,
    caption: t('dashboard.course.reminder.settings.sending_frequency_repeat'),
  },
]
